import Vue from 'vue';
import YmapPlugin from 'vue-yandex-maps';
import { settings } from './yandex-maps-settings';

Vue.use(YmapPlugin, settings);
